import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    wisepops: []
  },
  actions: actions,
  mutations: mutations,
  getters: getters
}
